import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { Typography } from '@app-velocity/ui';

import { I18nResources, useI18n } from '@app-velocity/i18n';

const ConfusionContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5),
}));

const Data = styled('header')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  fontSize: 16,
}));
const Value = styled(Typography)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
  svg: {
    fill: '#1b1b1b',
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
}));

export type SingleConfusionProps = {
  icon: ReactNode;
  value: string;
  title: I18nResources;
  description: string;
};

export const SingleConfusion = ({
  icon,
  value,
  title,
  description,
}: SingleConfusionProps) => {
  const { t } = useI18n();

  return (
    <ConfusionContainer>
      <Data>
        <Value>
          {icon}
          {value}
        </Value>
        <Title>{t(title)}</Title>
      </Data>
      <Typography>{description}</Typography>
    </ConfusionContainer>
  );
};
